import { Button, Container, Grid } from "@mui/material";
import React from "react";
import "./BottomBar.css";
import MobileSignUpStepper from "./MobileSignUpStepper";

function BottomBar(props) {
  const handleStepperState = () => {
    if (props.connections.length === 0) {
      alert("Please add a connection to continue!");
      return 1;
    }
    if (props.connections.length !== props.cart.length) {
      alert("Please confirm connection details to continue!");
      return 1;
    }
    if (props.stepperState.activeStep > 1) {
      if (!identityDetailsComplete()) {
        alert("Please complete Identity Information to continue!");
        return 2;
      }
      if (!paymentDetailsComplete()) {
        alert(
          'Please provide direct details, or select "Use another payment method" to continue!'
        );
        return 2;
      }
    }

    if (props.stepperState.activeStep + 1 <= props.stepperState.steps.length) {
      return props.stepperState.activeStep + 1;
    }
  };

  const identityDetailsComplete = () => {
    const expiryDateCheck =
      (props.user.identity.idType === "Medicare" &&
        props.user.identity.expiryDate === null) ||
      props.user.identity.expiryDate !== null;
    return (
      props.user.identity.dob !== null &&
      props.user.identity.idType !== null &&
      props.user.identity.idNumber !== null &&
      expiryDateCheck
    );
  };

  const paymentDetailsComplete = () => {
    return (
      props.caf.payment_method_type === "CHEQUE" ||
      (props.caf.payment_method_type === "DIRECT" &&
        props.payment.paymentDetails[0].bsb !== "" &&
        props.payment.paymentDetails[0].accountNumber !== "")
    );
  };

  const handleNext = () => {
    let newActiveStep = handleStepperState();
    props.stepperState.setActiveStep(newActiveStep);
  };

  const handleBack = () => {
    props.stepperState.setActiveStep((prevActiveStep) => prevActiveStep - 1);
  };

  return (
    <div className="bottomBar">
      {!props.mediaQuery &&
      props.stepperState.activeStep !== 4 &&
      props.stepperState.activeStep !== 0 ? (
        <Container>
          <Grid
            container
            direction="row"
            justifyContent="center"
            alignItems="center"
          >
            <Grid item p={2}>
              {props.stepperState.activeStep === 2 ||
              props.stepperState.activeStep === 3 ? (
                <Button
                  id="back-button"
                  variant="contained"
                  m={3}
                  p={2}
                  onClick={handleBack}
                >
                  <b>Back</b>
                </Button>
              ) : null}
            </Grid>
            <Grid item p={2}>
              {props.stepperState.activeStep === 1 ||
              props.stepperState.activeStep === 2 ? (
                <Button
                  id="next-button"
                  data-cy="next-button"
                  variant="contained"
                  onClick={handleNext}
                  m={3}
                  p={2}
                >
                  Next
                </Button>
              ) : null}
            </Grid>
          </Grid>
        </Container>
      ) : props.stepperState.activeStep !== 0 &&
        props.stepperState.activeStep !== 4 ? (
        <MobileSignUpStepper
          handleNext={handleNext}
          handleBack={handleBack}
          setActiveStep={props.setActiveStep}
          stepperState={props.stepperState}
        />
      ) : null}
    </div>
  );
}

export default BottomBar;
